(() => {
'use strict';
const A = window.ZORA_ASSETS || {};
const VIDEO_URL = A.video || 'assets/hero-scrub.mp4';
const VIDEO_BYTES = 5906529;
const POSTER = A.poster || 'assets/hero-poster.jpg';
const ENDING = A.ending || 'assets/hero-ending.jpg';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
const smoothstep = (p, e0, e1) => { const t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
function rng(seed) { let s = seed >>> 0; return () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296; }
const reduceMQ = matchMedia('(prefers-reduced-motion: reduce)');
const hero = $('.hero');

/* ---------- hero (homepage only) ---------- */
let applyHeroMode = () => {};
let unpinHero = () => {};
if (hero) {
  const staticHero = $('#static');
  staticHero.style.backgroundImage = `linear-gradient(to top,rgba(228,227,225,.96) 0%,rgba(228,227,225,.72) 45%,rgba(228,227,225,.1) 80%),url('${ENDING}')`;

  function splitEl(el, mode, seed, spread) {
    const text = el.textContent.trim();
    const html = el.innerHTML;
    el.innerHTML = '';
    const sr = document.createElement('span'); sr.className = 'sr'; sr.textContent = text; el.appendChild(sr);
    const vis = document.createElement('span'); vis.className = 'vis'; vis.setAttribute('aria-hidden', 'true');
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const r = rng(seed);
    let wordIndex = 0;
    const totalWords = text.split(/\s+/).length;
    const walk = (node, strong) => {
      node.childNodes.forEach(n => {
        if (n.nodeType === 3) {
          n.textContent.split(/(\s+)/).forEach(tok => {
            if (!tok) return;
            if (/^\s+$/.test(tok)) { vis.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'w' + (strong ? ' em' : '');
            if (mode === 'words') w.style.setProperty('--th', (wordIndex / totalWords * 0.5 + r() * 0.06).toFixed(3));
            if (mode === 'chars') {
              [...tok].forEach(ch => {
                const c = document.createElement('span'); c.className = 'c'; c.textContent = ch; c.setAttribute('data-c', ch);
                c.style.setProperty('--th', (r() * spread).toFixed(3));
                w.appendChild(c);
              });
            } else w.textContent = tok;
            if (strong) { const b = document.createElement('strong'); while (w.firstChild) b.appendChild(w.firstChild); w.appendChild(b); }
            vis.appendChild(w); wordIndex++;
          });
        } else walk(n, strong || n.tagName === 'STRONG');
      });
    };
    walk(tmp, false);
    el.appendChild(vis);
  }
  $$('[data-split]').forEach((el, i) => {
    const mode = el.dataset.split; if (mode === 'none') return;
    const band = el.closest('.band');
    splitEl(el, mode, 1000 + i * 17, parseFloat(band.dataset.spread || '0.55'));
  });

  const stage = $('#stage'), video = $('#hero'), posterLayer = $('#poster'), ring = $('#ring'), cue = $('#cue'), chips = $('#chips');
  const bands = $$('.band').map(b => ({ el: b, a: +b.dataset.a, b: +b.dataset.b, ramp: b.dataset.ramp ? +b.dataset.ramp : null, op: -1, k: -1, live: false }));
  let chipsOp = -1, cueHidden = false;
  let heroOnScreen = true, scrubOn = false, initDone = false, loadK = 0, loadStart = 0;

  function heroProgress() {
    const range = hero.offsetHeight - innerHeight;
    return range > 0 ? clamp(-hero.getBoundingClientRect().top / range, 0, 1) : 0;
  }
  function updateCaptions(p) {
    const nowK = loadK;
    bands.forEach((bd, i) => {
      const f = Math.min(0.02, (bd.b - bd.a) / 3);
      const op = (i === 0 ? 1 : smoothstep(p, bd.a, bd.a + f)) * (i === bands.length - 1 ? 1 : 1 - smoothstep(p, bd.b - f, bd.b));
      let k = clamp((p - bd.a) / (bd.ramp || Math.min(0.025, (bd.b - bd.a) * 0.35)), 0, 1);
      if (i === 0) k = Math.max(k, nowK);
      if (Math.abs(op - bd.op) > 0.005) { bd.op = op; bd.el.style.opacity = op.toFixed(3); }
      if (Math.abs(k - bd.k) > 0.008) { bd.k = k; bd.el.style.setProperty('--k', k.toFixed(3)); }
      const live = op > 0.5; if (live !== bd.live) { bd.live = live; bd.el.classList.toggle('live', live); }
    });
    const last = bands[bands.length - 1];
    if (Math.abs(last.op - chipsOp) > 0.005) { chipsOp = last.op; chips.style.opacity = last.op.toFixed(3); chips.style.setProperty('--k', last.k.toFixed(3)); }
    const hide = p > 0.04; if (hide !== cueHidden) { cueHidden = hide; cue.classList.toggle('hide', hide); }
  }

  let seekBusy = false, pendingTime = null;
  function requestSeek(t) {
    if (!video.duration) return;
    if (seekBusy) { pendingTime = t; return; }
    seekBusy = true; video.currentTime = t;
  }
  video.addEventListener('seeked', () => { seekBusy = false; if (pendingTime !== null) { const t = pendingTime; pendingTime = null; requestSeek(t); } });
  video.addEventListener('error', () => { seekBusy = false; pendingTime = null; failVideo(); });

  let target = 0, shown = 0, rafId = null, lastTick = 0;
  function tick(now) {
    const dt = Math.min(100, now - (lastTick || now)); lastTick = now;
    const k = 0.16;
    shown += (target - shown) * (1 - Math.pow(1 - k, dt / 16.667));
    if (loadK < 1) { if (!loadStart) loadStart = now; loadK = clamp((now - loadStart) / 1400, 0, 1); loadK = loadK * loadK * (3 - 2 * loadK); }
    const converged = Math.abs(target - shown) < 0.0005 && loadK >= 1;
    if (converged) { shown = target; rafId = null; lastTick = 0; } else rafId = requestAnimationFrame(tick);
    requestSeek(shown * video.duration);
    updateCaptions(shown);
  }
  function onScroll() { target = heroProgress(); if (rafId === null && heroOnScreen) rafId = requestAnimationFrame(tick); }
  new IntersectionObserver(es => { heroOnScreen = es[0].isIntersecting; if (heroOnScreen && scrubOn) onScroll(); }).observe(hero);

  let started = false;
  function startBlobFetch() { if (started) return; started = true; loadHeroBlob().catch(failVideo); }
  async function loadHeroBlob() {
    const ctrl = new AbortController();
    let watchdog = setTimeout(() => ctrl.abort(), 20000);
    const res = await fetch(VIDEO_URL, { priority: 'low', signal: ctrl.signal, mode: 'cors' });
    if (!res.ok || !res.body) throw new Error('video');
    const total = Number(res.headers.get('Content-Length')) || VIDEO_BYTES;
    const reader = res.body.getReader(); const chunks = []; let got = 0, lastRing = 0;
    for (;;) {
      const { done, value } = await reader.read(); if (done) break;
      clearTimeout(watchdog); watchdog = setTimeout(() => ctrl.abort(), 20000);
      chunks.push(value); got += value.length;
      const frac = Math.min(1, got / total), now = performance.now();
      if (now - lastRing > 100 || frac === 1) { lastRing = now; ring.style.setProperty('--ld', Math.round(126 * (1 - frac))); }
    }
    clearTimeout(watchdog); ring.style.setProperty('--ld', 0);
    video.src = URL.createObjectURL(new Blob(chunks, { type: 'video/mp4' })); video.load();
    video.addEventListener('canplay', () => { requestSeek(heroProgress() * video.duration); stage.classList.add('video-ready'); }, { once: true });
  }
  function failVideo() { ring.style.opacity = 0; stage.classList.add('video-failed'); }
  function initHeroOnce() {
    if (initDone) return; initDone = true;
    posterLayer.style.backgroundImage = `url('${POSTER}')`;
    const img = new Image(); img.onload = startBlobFetch; img.onerror = startBlobFetch; img.src = POSTER;
    setTimeout(startBlobFetch, 4000);
  }

  const GATES = ['(max-width: 720px)', '(orientation: portrait) and (max-width: 1024px)', '(orientation: portrait) and (pointer: coarse)', '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)', '(prefers-reduced-motion: reduce)'];
  function enableScrub() {
    if (scrubOn) return; scrubOn = true;
    initHeroOnce();
    addEventListener('scroll', onScroll, { passive: true });
    bands.forEach(b => { b.op = -1; b.k = -1; }); chipsOp = -1;
    unpinFinalStates();
    updateCaptions(heroProgress()); onScroll();
  }
  function disableScrub() {
    if (!scrubOn) return; scrubOn = false;
    removeEventListener('scroll', onScroll);
    if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
  }
  applyHeroMode = () => { if (GATES.some(q => matchMedia(q).matches)) disableScrub(); else enableScrub(); };
  const MQLS = GATES.map(q => matchMedia(q)); MQLS.forEach(m => m.addEventListener('change', applyHeroMode));
  const nav = $('#nav');
  if (nav) new IntersectionObserver(es => nav.classList.toggle('solid', !es[0].isIntersecting), { rootMargin: '-80px 0px 0px 0px' }).observe(stage);
} else {
  const nav = $('#nav'); if (nav) nav.classList.add('solid');
}

/* ---------- section entrances ---------- */
const secIO = new IntersectionObserver(es => es.forEach(e => {
  if (e.isIntersecting) { e.target.classList.add('in', 'live'); setTimeout(() => e.target.classList.add('done'), 1600); }
  else e.target.classList.remove('live');
}), { threshold: 0.12 });
$$('.sec, .divider').forEach(s => secIO.observe(s));

/* ---------- the self-drawing raster and the timeline ---------- */
const raster = $('#raster'), stepsSec = $('#werking'), track = $('#track');
if (raster) {
  const W = 1200, H = 800, g = 80; raster.setAttribute('viewBox', `0 0 ${W} ${H}`);
  let s = '';
  for (let x = g; x < W; x += g) s += `<line x1="${x}" y1="0" x2="${x}" y2="${H}" pathLength="1000"/>`;
  for (let y = g; y < H; y += g) s += `<line x1="0" y1="${y}" x2="${W}" y2="${y}" pathLength="1000"/>`;
  for (let x = g; x < W; x += g * 2) for (let y = g; y < H; y += g * 2) s += `<g stroke="#9F5F42" stroke-width="1" opacity=".5"><path d="M${x} ${y - 5}v10M${x - 5} ${y}h10"/></g>`;
  raster.innerHTML = s;
  raster.querySelectorAll('line').forEach(l => l.setAttribute('style', 'stroke-dasharray:1000;stroke-dashoffset:var(--dash,1000)'));
}
const tls = $$('.tl'), tlOn = tls.map(() => false); let tlLast = -1, rasterLast = -1;
function driveScroll() {
  if (document.body.classList.contains('pinned')) return;
  if (raster && stepsSec) {
    const r = stepsSec.getBoundingClientRect();
    const p = clamp((innerHeight - r.top) / (innerHeight + r.height * 0.6), 0, 1);
    const v = Math.round((1 - p) * 1000);
    if (v !== rasterLast) { rasterLast = v; raster.style.setProperty('--dash', v); }
  }
  if (track) {
    const t = track.getBoundingClientRect();
    const f = clamp((innerHeight * 0.75 - t.top) / t.height, 0, 1);
    if (Math.abs(f - tlLast) > 0.01) { tlLast = f; track.style.setProperty('--f', f.toFixed(3)); tls.forEach((el, i) => { const on = f > (i + 0.5) / tls.length; if (on !== tlOn[i]) { tlOn[i] = on; el.classList.toggle('on', on); } }); }
  }
}
addEventListener('scroll', driveScroll, { passive: true });

/* ---------- the session: press and hold ---------- */
const session = $('#session');
let holdDone = false, setTimer = () => {}, ccards = [];
if (session) {
  const holdbtn = $('#holdbtn'), hint = $('#hint'), timer = $('#timer'), leds = $('#leds'); ccards = $$('.ccard');
  (function buildLeds() {
    const pts = []; const r = rng(42);
    for (let y = 24; y < 290; y += 15) for (let x = 24; x < 300; x += 15) {
      const inEye = (x - 112) ** 2 / 34 ** 2 + (y - 110) ** 2 / 17 ** 2 < 1 || (x - 208) ** 2 / 34 ** 2 + (y - 110) ** 2 / 17 ** 2 < 1;
      const inMouth = (x - 160) ** 2 / 40 ** 2 + (y - 220) ** 2 / 19 ** 2 < 1;
      const inNose = y > 124 && y < 180 && Math.abs(x - 160) < 14 + (y - 124) * 0.26;
      if (inEye || inMouth || inNose) continue;
      pts.push({ x, y, d: Math.hypot(x - 160, y - 150) + r() * 20 });
    }
    pts.sort((a, b) => a.d - b.d);
    leds.innerHTML = pts.map((p, i) => `<circle class="ledglow" cx="${p.x}" cy="${p.y}" r="4" style="--t:${(i / pts.length).toFixed(3)}"/><circle class="led" cx="${p.x}" cy="${p.y}" r="2.3" style="--t:${(i / pts.length).toFixed(3)}"/>`).join('');
  })();
  let holdP = 0, holdRaf = null, holding = false, holdLast = 0, timerLast = '';
  setTimer = p => {
    const s = Math.round(600 * (1 - p)); const t = `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
    if (t !== timerLast) { timerLast = t; timer.textContent = t; }
  };
  function holdTick(now) {
    const dt = Math.min(60, now - (holdLast || now)); holdLast = now;
    if (holdDone) holdP = 1;
    else if (holding) holdP = clamp(holdP + dt / 2600, 0, 1);
    else holdP = clamp(holdP - dt / 1400, 0, 1);
    session.style.setProperty('--p', holdP.toFixed(3)); setTimer(holdP);
    if (holdP >= 1 && !holdDone) completeSession();
    if ((holding && holdP < 1) || (!holding && holdP > 0 && !holdDone)) holdRaf = requestAnimationFrame(holdTick); else { holdRaf = null; holdLast = 0; }
  }
  function startHold(e) { if (holdDone || reduceMQ.matches) return; e.preventDefault(); holding = true; session.classList.add('holding'); hint.textContent = 'Houd vast. Het licht komt op.'; if (holdRaf === null) holdRaf = requestAnimationFrame(holdTick); }
  function endHold() { if (!holding) return; holding = false; session.classList.remove('holding'); if (!holdDone) { hint.textContent = 'Houd ingedrukt om een sessie te starten.'; if (holdRaf === null) holdRaf = requestAnimationFrame(holdTick); } }
  function completeSession() {
    holdDone = true; holding = false; session.classList.remove('holding'); session.classList.add('done');
    holdbtn.textContent = 'Sessie klaar'; hint.textContent = 'Sessie klaar. Morgen weer.';
    ccards.forEach((c, i) => setTimeout(() => c.classList.add('lit'), 200 + i * 260));
    setTimeout(() => { holdbtn.textContent = 'Nog een sessie'; holdbtn.onclick = resetSession; }, 1800);
  }
  function resetSession() { holdbtn.onclick = null; holdDone = false; holdP = 0; session.classList.remove('done'); session.style.setProperty('--p', 0); setTimer(0); holdbtn.textContent = 'Start een sessie'; hint.textContent = 'Houd ingedrukt om een sessie te starten.'; ccards.forEach(c => c.classList.remove('lit')); }
  holdbtn.addEventListener('pointerdown', startHold); addEventListener('pointerup', endHold); addEventListener('pointercancel', endHold);
  holdbtn.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) startHold(e); });
  holdbtn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') endHold(); });
  $$('.sw').forEach(b => b.addEventListener('click', () => { $$('.sw').forEach(x => x.setAttribute('aria-pressed', x === b)); session.style.setProperty('--led', b.dataset.c); }));
  new IntersectionObserver(es => { if (es[0].isIntersecting) session.style.setProperty('--draw', 0); }, { threshold: 0.3 }).observe(session);
}

/* ---------- faq ---------- */
const faq = $('#faq');
if (faq) {
  const QA = [
    ['Werkt het echt?', 'Rood licht van 630 nm is het best onderzochte LED-licht voor de huid. Verwacht geen wonder na één avond. Verwacht wel een verschil na weken van dagelijks gebruik, vooral in teint en helderheid.'],
    ['Is het veilig voor mijn ogen?', 'Het licht is fel. Daarom zitten er oogbeschermers bij, en je houdt je ogen dicht tijdens de sessie.'],
    ['Zit het masker prettig?', 'Het masker is van zacht, flexibel silicoon en volgt de vorm van je gezicht. De hoofdbanden houden het op zijn plek zonder te knellen.'],
    ['Hoe vaak moet ik het gebruiken?', 'Dagelijks werkt het best. Eén sessie duurt tien minuten en stopt vanzelf.'],
    ['Heb ik een stopcontact nodig?', 'Nee. De afstandsbediening heeft een accu van 1200 mAh, goed voor ongeveer twee uur gebruik. Opladen gaat via USB.'],
    ['Zit er infrarood in?', 'Nee. Het ZORA-masker gebruikt rood licht van 630 nm, plus blauw en groen. Geen infrarood.'],
    ['Kan ik mijn hals ook meenemen?', 'Ja. Het losse halsstuk heeft 96 eigen LED\'s.']
  ];
  faq.innerHTML = QA.map(([q, a], i) => `<div class="q" id="q${i}"><button type="button" aria-expanded="false" aria-controls="a${i}"><span>${q}</span><span class="pm" aria-hidden="true">+</span></button><div class="a" id="a${i}"><div><p>${a}</p></div></div></div>`).join('');
  $$('.q button').forEach(b => b.addEventListener('click', () => { const q = b.parentElement, open = q.hasAttribute('open'); q.toggleAttribute('open', !open); b.setAttribute('aria-expanded', String(!open)); }));
}

/* ---------- product gallery thumbs ---------- */
const mainImg = $('#mainImg');
if (mainImg) $$('.thumb').forEach(t => t.addEventListener('click', () => { mainImg.src = t.dataset.src; $$('.thumb').forEach(x => x.classList.toggle('on', x === t)); }));

/* ---------- reduced motion, both directions ---------- */
function pinToFinalStates() {
  document.body.classList.add('pinned');
  if (raster) raster.style.setProperty('--dash', 0);
  if (track) { track.style.setProperty('--f', 1); tls.forEach(t => t.classList.add('on')); }
  if (session) { session.style.setProperty('--draw', 0); session.style.setProperty('--p', 1); setTimer(1); ccards.forEach(c => c.classList.add('lit')); }
  $$('.sec, .divider').forEach(s => s.classList.add('in', 'done'));
}
function unpinFinalStates() {
  if (!document.body.classList.contains('pinned')) return;
  document.body.classList.remove('pinned'); rasterLast = -1; tlLast = -1; tlOn.fill(false); tls.forEach(t => t.classList.remove('on'));
  if (session && !holdDone) { session.style.setProperty('--p', 0); setTimer(0); ccards.forEach(c => c.classList.remove('lit')); }
  driveScroll();
}
reduceMQ.addEventListener('change', e => { if (e.matches) pinToFinalStates(); else { unpinFinalStates(); applyHeroMode(); } });
document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));

if (reduceMQ.matches) pinToFinalStates();
applyHeroMode();
driveScroll();
requestAnimationFrame(() => document.body.classList.add('ready'));
})();
